import { Link } from "react-router-dom";
import { Empty, ErrorState, Loading } from "../States";
import { moduleName, runProgress, type RunView } from "./moduleFlow";
import { TableScroll } from "../TableScroll";

/** A run's state as a pill, in the words runProgress uses. */
export function RunState({ run }: { run: RunView }) {
  const p = runProgress(run);
  return <span className={`pill ${p.tone}`}>{p.label}</span>;
}

/** The newest runs this person may read, each linked to its detail. */
export function RunsBody({ loading, error, data }: { loading: boolean; error: unknown; data: RunView[] | undefined }) {
  if (loading) return <Loading what="Loading runs" />;
  if (error) return <ErrorState error={error} />;
  if (!data || data.length === 0) {
    return <Empty title="No runs yet">Runs you and others start in your packages appear here.</Empty>;
  }
  return (
    <section className="card" style={{ padding: 0, overflowX: "auto" }}>
      <TableScroll label="Module runs">
      <table>
        <thead><tr><th>Module</th><th>Package</th><th>Tag</th><th>State</th><th aria-label="Open the run" /></tr></thead>
        <tbody>
          {data.map((r) => (
            <tr key={r.id}>
              <td>{moduleName(r.request_type)}</td>
              <td className="mono">{r.package ?? "none"}</td>
              <td className="mono">{r.tag ?? (r.request_type.startsWith("package") ? "whole package" : "none")}</td>
              <td><RunState run={r} /></td>
              <td><Link to={`/modules/runs/${r.id}`}>Open</Link></td>
            </tr>
          ))}
        </tbody>
      </table>
      </TableScroll>
    </section>
  );
}
